import React, { Component } from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';

import CustomDatepicker from './Datepicker/CustomDatepicker';
import Validator from '../helpers/validation';

const schema = [
	{
		name: 'comment',
		fieldName: 'Текст',
		rules: 'required'
	},
	{
		name: 'deadline',
		fieldName: 'Сделать до',
		rules: 'required'
	}
];

class TaskForm extends Component {
	state = {
		comment: '',
		deadline: '',
		submitErrors: []
	}

	componentDidMount () {
		this.validator = new Validator(this.form, schema);
	}

	handleSubmit = e => {
		e.preventDefault();
		
		const validation = this.validator.validateForm();

		if (validation.valid) {
			const data = serialize(this.form, { hash: true })
			this.props.onSubmit({...data, user_id: this.props.userId});
			this.setState({
				comment: '',
				deadline: ''
			});
		}
		else {
			this.setState({
				submitErrors: validation.errors
			});
		}
	}

	handleInputChange = e => {
		const value = e.target.value;

		this.setState({
			comment: value,
			submitErrors: []
		});
	}

	handleDateChange = date => {
		this.setState({
			deadline: date,
			submitErrors: []
		});
	}

	render () {
		const { comment, deadline } = this.state;

		return (
			<form action="" method="" onSubmit={this.handleSubmit} className="custom-form add-task-form" ref={c => this.form = c}>
				<h4 className="text-center mr-bottom-20">Добавить задачу</h4>
				{this.state.submitErrors.length ?
					<div className="alert alert-danger" role="alert">
						{this.state.submitErrors.map((error, key) => <div key={`error_${key}`}>{error}</div>)}
					</div> : null
				}
				<div className="row">
					<div className="col-xs-6">
						<div className="col-xs-3 custom-form__label">Текст:</div>
						<div className="col-xs-8 client-title max">
							<textarea className="custom-textarea" name="comment" value={comment} onChange={this.handleInputChange}/>
						</div>
					</div>
					<div className="col-xs-4">
						<div className="col-xs-4 custom-form__label with-select">Сделать до:</div>
						<input type="hidden" name="deadline" value={deadline} />
						<div className="col-xs-7">
							<CustomDatepicker
								selectedDay={deadline}
								onDayChange={this.handleDateChange}
								disabledDays={[{before: new Date()}]}
							/>
						</div>
					</div>
					<div className="col-xs-2">
						<button type="submit" className="btn btn-success">Создать</button>
					</div>
				</div>
			</form>
		);
	}
}

TaskForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	userId: PropTypes.number
};

export default TaskForm;


// WEBPACK FOOTER //
// ./components/TaskForm.js